import React, {useEffect, useState } from "react";
import { getAllSectors, addSector } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";
import { alertSuccess, alertError } from '../../utils/alerts';
import { Link } from "react-router-dom/cjs/react-router-dom";

const INIT_STATE = {
    name: "",
};

export default function Sectors() {
    const [loading, setLoading] = useState(false);
    const [sectors, setSectors ] = useState(null);
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);

    useEffect(() => {
        setLoading(true);
        getAllSectors()
            .then((res) => { 
                if(res.data.success){
                    setSectors(res.data.data);  
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err?.response?.data?.message)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        if(data.name){
            setLoading(true);
            addSector(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
        }
    };


    return (
        <>
            <div className="spur-card-menu">
                <button data-toggle="modal" data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">CREATE</button>
            </div>
            
            <h1 className="dash-title"><Link to="/sales" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Sectors</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && sectors && sectors) ? 
                                    <div className="table-responsive">
                                        {(sectors && sectors.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Name of Sector</th><th>Actions</th></tr></thead>
                                            <tbody>
                                                {sectors && sectors.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.name && row?.name}</td>
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById("/sales/sector", row._id)} 
                                                                className='btn btn-preview'
                                                                disabled
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD SECTOR</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Name <span>*</span></label>
                                    <input type="text" name="name" className="form-control" required placeholder="Name of Sector" 
                                     onChange={handleChange} defaultValue={state.name && state.name} disabled={loading} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
